import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { HomeProvider } from './Context/HomeContext';
import { useHomeDataLoader } from './Hook/useHomeDataLoader';
import SearchResults from './Pages/SearchResult';
import ContactUs from './Pages/ContactUs';
import AboutUs from './Pages/AboutUs';
import './App.css'
import Home from './Pages/Home';
import BlogDetails from './Pages/Blogs';
import Footer from './Component/Footer';
import TermsAndConditions from './Pages/TermsAndConditions';
import PrivacyPolicy from './Pages/Privacy';
import SubCategoryPage from './Pages/SubCategory';
import CategoryPage from './Pages/Category';
import NotFound from './Pages/NotFound';
import Navbar1 from './Component/Navbar';
import Navbar2 from './Component/Navbar2';




const AppContent = () => {
  useHomeDataLoader(); // ✅ This ensures recentBlogs and homeData are loaded

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
     
     <Navbar1/>
     <Navbar2/>
      <div style={{ flex: 1 }}>
        <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/search" element={<SearchResults />} />
        <Route path="/ContactUs" element={<ContactUs />} />
        <Route path="/AboutUs" element={<AboutUs/>} />
        <Route path="/blog/:slug" element={<BlogDetails />} />
        <Route path="/TermsAndConditions" element={<TermsAndConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/subcategory/:slug" element={<SubCategoryPage />} />
        <Route path="/category/:slug" element={<CategoryPage />} />
        <Route path="*" element={<NotFound />} />

        </Routes>
      </div>
      <Footer/>
   
    </div>
  );
};

export default function App() {
  return (
    <HomeProvider>
      <Router>
        <AppContent />
      </Router>
    </HomeProvider>
  );
}
